import { render, staticRenderFns } from "./relatorio-detalhes.vue?vue&type=template&id=68675590&scoped=true"
import script from "./relatorio-detalhes.vue?vue&type=script&lang=ts"
export * from "./relatorio-detalhes.vue?vue&type=script&lang=ts"
import style0 from "./relatorio-detalhes.vue?vue&type=style&index=0&id=68675590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68675590",
  null
  
)

export default component.exports